import { Input, Popover, Button } from 'ant-design-vue'
import Passenger from './input-passenger.vue'
import InputNumber from '@/components/input-number'
/* istanbul ignore next */
Passenger.install = function (Vue) {
  Vue.component(Passenger.name, Passenger)
  Vue.use(Input)
  Vue.use(Popover)
  Vue.use(Button)
  Vue.use(InputNumber)
}

export default Passenger
